import { Typography } from '@mui/material';

export default function CallSummarySection({ summary }: { summary?: string }) {
  return (
    <>
      <Typography color='primary' fontWeight={600} my={2}>
        Call Summary
      </Typography>
      <Typography
        sx={{
          background: '#fff',
          border: '1px solid #ECECEC',
          borderRadius: '10px',
          p: 1.5
        }}
      >
        {summary}
      </Typography>
    </>
  );
}
